import React from 'react'
import KeyDropdownValue from '../shared/KeyDropdownValue'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const JobSelect = ({ groups, positions, onChangeGroups, onChangePosition }) => {
  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('job-title')}</h3>
      <div className="register__row">
        <KeyDropdownValue
          title={tRegister('job-location')}
          placeholder={tRegister('job-location-placeholder')}
          name="group_id"
          isMulti
          options={groups}
          optionsLabel="external_identifier"
          optionsId="id"
          onChange={onChangeGroups}
        />
        <KeyDropdownValue
          title={tRegister('job-category')}
          placeholder={tRegister('job-category-placeholder')}
          name="position_id"
          options={positions}
          optionsLabel="name"
          optionsId="id"
          onChange={onChangePosition}
        />
      </div>
    </div>
  )
}

export default JobSelect
